export default "__VITE_ASSET__Dq2Po3Fa__"